import { useState, useEffect, useContext } from 'react';
import {
  Card,
  Divider,
  Checkbox,
  Collapse,
  Space,
  Slider,
  Row,
  Col,
  Typography,
  Modal,
  Spin,
  Tabs,
} from 'antd';
import {
  setBoundaryColor,
  getSLDForLayer,
  getSLDForLayerCatagorical,
  isAddedVectorLayer,
  buildArcGISStyle,
  setArcGISLayerStyle,
} from './utils';
import Button from 'antd/es/button';
import WorkspaceContext from '../context/WorkspaceContext';
import {
  CloseOutlined,
  InfoCircleOutlined,
  UndoOutlined,
  // TableOutlined,
} from '@ant-design/icons';
import { Tooltip } from 'antd';
// import FilterModal from './FilterModal/FilterModal';
import './index.css';
import WCS from '../lib/WCS';
import ForestDataMapLegend from './ForestDataMapLegend';
import AppliedFilters from './AppliedFilters';
import chroma from 'chroma-js';
import FilterModalIts from './FilterModal/FilterModalIts';
import LayerTreeCustomBoundary from './LayerTreeComponents/LayerTreeCustomBoundary';
import { ITS_DATA_VALID_YEARS } from '../util/ITS';
import { BoundaryCheck } from '../util/BoundaryName';
import ForestDataMapBoundaryColor from './MapButtons/ForestDataMapBoundaryColor';
import './styles.css';
import './ForestDataMapLayerTree.css';
import LayerTreeControl from './LayerTreeComponents/LayerTreeControl';
import ForestDataMapAddLayer from './MapButtons/ForestDataMapAddLayer';
import { useNavigate } from 'react-router-dom';
import { DownloadContext } from '../context/DownloadContext';
import { formatTitle } from '../util/TitleHelper';

const { Text } = Typography;

// Width of the layer panel's cards. The scroll container is 342px; this
// leaves room for a classic (non-overlay) vertical scrollbar, up to 17px on
// Windows, so the panel never needs a horizontal scrollbar.
const LAYER_PANEL_CONTENT_WIDTH = 325;

const ForestDataMapLayerTree = (props) => {
  const { selectedDatasets, setSelectedDatasets } =
    useContext(WorkspaceContext);
  const { loading } = useContext(DownloadContext);
  const navitage = useNavigate();
  const [tab, setTab] = useState(loading ? '2' : '1');

  useEffect(() => {
    let values = {};
    let ops = {};
    if (!props.layers) return;
    for (var i = 0; i < props.layers.length; i++) {
      let layer = props.layers[i];
      let key =
        layer.getProperties().service_url +
        '/' +
        layer.getProperties().layer_name;
      values[key] = layer.getVisible();
      ops[key] = layer.getOpacity();
    }

    let newValueRanges = { ...props.valueRanges };
    let changed = false;

    for (var j = 0; j < selectedDatasets.length; j++) {
      let dataset = selectedDatasets[j];
      let gis_services = props.getGisService(dataset);
      let found = false;
      for (i = 0; i < props.layers.length; i++) {
        let layer = props.layers[i];
        if (
          gis_services.service_url === layer.getProperties().service_url &&
          gis_services.layer_name === layer.getProperties().layer_name
        ) {
          found = true;
          break;
        }
      }

      let key = props.getItemKey(dataset);

      if (!found) {
        values[key] = true;
        ops[key] = props.opacities[key] ?? 0.7;
      }

      if (
        newValueRanges[key] === undefined &&
        dataset.data_type === 'raster' &&
        dataset.dataset_metadata.filter((e) => e.name === 'min_value')[0] !==
          undefined &&
        dataset.dataset_metadata.filter((e) => e.name === 'max_value')[0] !==
          undefined
      ) {
        let min = dataset.dataset_metadata.filter(
          (e) => e.name === 'min_value'
        )[0].float_value;
        let max = dataset.dataset_metadata.filter(
          (e) => e.name === 'max_value'
        )[0].float_value;
        newValueRanges[key] = [min, max];
        changed = true;
      }
    }

    // below loops are to check for proper settings when loading workspaces

    // if new dataset added, check with checked datasets to make sure the checked settings are correct
    Object.keys(props?.checkedDatasets).forEach((key) => {
      values[key] = props?.checkedDatasets[key];
    });

    // make sure checked datasets that are checked are visible
    Object.keys(values)
      .filter(function (key) {
        return values[key];
      })
      .forEach((key) => {
        for (i = 0; i < props.layers.length; i++) {
          let layer = props.layers[i];
          if (
            key ===
            layer.getProperties().service_url +
              '/' +
              layer.getProperties().layer_name
          ) {
            layer.setVisible(values[key]);
          }
        }
      });

    props.setCheckedDatasets(values);
    props.setOpacities(ops);
    if (changed) {
      props.setValueRanges(newValueRanges);
    }
    // setLayers(props.layers);
  }, [selectedDatasets, props.valueRanges]);

  useEffect(() => {
    let checkedQueries = {};
    props.queryLayers.forEach((layer) => {
      let isVisible = layer.getVisible();
      checkedQueries[layer.getProperties()['layerId']] = isVisible;
    });

    for (var i = 0; i < props.queryLayerInfo.length; i++) {
      let layerId = props.queryLayerInfo[i].mapping[0].layerId;
      let found = false;
      props.queryLayers.forEach((layer) => {
        if (layer.getProperties()['layerId'] === layerId) {
          found = true;
          return;
        }
      });

      if (!found) {
        let layerInfo = props.queryLayerInfo;
        layerInfo.splice(i, 1);
        props.setQueryLayerInfo(layerInfo);
      }
    }

    props.setCheckedQuerysets(checkedQueries);
  }, [props.queryLayers]);

  const vectorValueChange = (values, item) => {
    let sql = [];

    let itemKey = props.getItemKey(item);
    let gis_service = props.getGisService(item);
    let color = null;
    Object.keys(values)
      .filter((key) => values[key] !== undefined && values[key].length > 0)
      .forEach((key) => {
        let value = values[key];
        let data_type = props.filter_options[itemKey]?.filter(
          (e) => e.label == key
        );
        if (key == 'color') {
          color = Array.isArray(value) ? value[0] : value;
        } else if (data_type) {
          if (data_type.length > 0) {
            data_type = data_type[0].type;
          }

          if (data_type == 'string') {
            let string_values = '';
            if (typeof value === 'string') {
              string_values = "'" + value.split(',').join("', '") + "'";
            } else {
              string_values = "'" + value.join("', '") + "'";
            }

            sql.push(`${key} IN (${string_values})`);
          } else if (data_type == 'number') {
            sql.push(`${key} >= ${value[0]} AND ${key} <= ${value[1]}`);
          }
        } else {
          let string_values = '';
          string_values = "'" + value.join("' , '") + "'";
          sql.push(`${key} IN (${string_values})`);
        }
      });

    let final_sql = sql.join(' AND ');
    final_sql.replaceAll(' ', '+');
    let layer = getLayer(item);
    if (layer) {
      layer.getSource().updateParams({ STYLES: undefined });
      if (color) {
        setBoundaryColor(layer.getSource(), gis_service.layer_name, color);
      }
      layer.getSource().updateParams({ cql_filter: final_sql });

      let newValueRanges = { ...props.valueRanges };
      let key = props.getItemKey(item);

      newValueRanges[key] = final_sql;
      props.setValueRanges(newValueRanges);
    }
  };

  const rasterValueChange = async (values, item) => {
    let layer = getLayer(item);
    if (layer) {
      let newValueRanges = { ...props.valueRanges };
      let key = props.getItemKey(item);
      newValueRanges[key] = values;
      props.setValueRanges(newValueRanges);
      let min;
      let max;
      let gis_service = props.getGisService(item);
      const nilValue = await WCS.getDescribeCoverageNilValue(
        gis_service.layer_name
      );

      // Checks if reseting using max and min numbers
      const allNumbers = values.every((value) => typeof value === 'number');
      if (gis_service?.categorical_values && !allNumbers) {
        let sld = getSLDForLayerCatagorical(
          gis_service.layer_name,
          newValueRanges[key],
          nilValue
        );
        layer.getSource().updateParams({ STYLES: undefined });
        layer.getSource().updateParams({ SLD_BODY: sld });
      } else if (values.length == 2 && !allNumbers) {
        let sld = getSLDForLayer(
          gis_service.layer_name,
          values[0]?.color
            ? values[0]?.color
            : gis_service.color_map.color_map_entries[0].color,
          values[1]?.color
            ? values[1]?.color
            : gis_service.color_map.color_map_entries[1].color,
          max,
          min,
          values[1].value,
          values[0].value
        );
        layer.getSource().updateParams({ STYLES: undefined });
        layer.getSource().updateParams({ SLD_BODY: sld });
      } else {
        if (item.dataset_metadata) {
          min = item.dataset_metadata.filter((e) => e.name === 'min_value')[0]
            .float_value;
          max = item.dataset_metadata.filter((e) => e.name === 'max_value')[0]
            .float_value;
        } else {
          min = gis_service.dataset_collections[0].minimum_value;
          max = gis_service.dataset_collections[0].maximum_value;
        }
        let sld = getSLDForLayer(
          gis_service.layer_name,
          gis_service.color_map.color_map_entries.length > 0
            ? gis_service.color_map.color_map_entries[0].color
            : '#D6B2FF',
          gis_service.color_map.color_map_entries.length > 1
            ? gis_service.color_map.color_map_entries[1].color
            : '#3B0875',
          max,
          min,
          values[1],
          values[0]
        );
        layer.getSource().updateParams({ STYLES: undefined });
        layer.getSource().updateParams({ SLD_BODY: sld });
      }
    }
  };

  useEffect(() => {
    // Update when filter is submitted
    if (Object.keys(props.filterItems).length > 0) {
      Object.keys(props.filterItems).forEach((filterKey) => {
        let newLoading = { ...props.loading_datasets };
        newLoading[filterKey] = true;
        const setLoading = async (newLoading) => {
          await props.setLoadingDatasets(newLoading);
        };

        setLoading(newLoading);

        let newValue = props.filterItems[filterKey];
        let newFilterDatasets = { ...props.filtersDatasets };
        newFilterDatasets[filterKey] = newValue;
        props.setFilterDatasets(newFilterDatasets);

        let item = selectedDatasets.filter((e) => {
          return props.getItemKey(e) === filterKey;
        })[0];
        if (!item) return;
        let gis_service = props.getGisService(item);
        if (gis_service.service_type === 'ArcGIS') {
          const removeLayer = async (layer) => {
            const index = props.layers.indexOf(layer);
            if (index > -1) {
              await props.layers.splice(index, 1);
            }

            let mapLayerToRemove = null;
            await props.map.getLayers().forEach((e) => {
              if (
                e.getProperties().service_url ===
                  layer.getProperties().service_url &&
                e.getProperties().layer_name ===
                  layer.getProperties().layer_name
              ) {
                mapLayerToRemove = e;
              }
            });

            props.map.removeLayer(mapLayerToRemove);

            props.map.getLayers().forEach(() => {});
          };

          let layer = getLayer(item);
          removeLayer(layer);

          // const setArcMap = async (newValue, item) => {
          //   // await arcGISValueChange(newValue, item);
          // };

          // setArcMap(newValue, item);
        } else if (
          item.data_type === 'vector' ||
          gis_service.data_type === 'vector'
        ) {
          vectorValueChange(newValue, item);
        } else {
          rasterValueChange(newValue['values'], item);
        }

        newLoading = { ...props.loading_datasets };
        newLoading[filterKey] = false;
        setLoading(newLoading);
      });
    }
  }, [props.filterItems]);

  const handleCheckboxChange = (event, item) => {
    let layer = getLayer(item);
    let key = props.getItemKey(item);

    if (layer) {
      layer.setVisible(event.target.checked);
      let newCheckedValues = { ...props.checkedDatasets };
      newCheckedValues[key] = event.target.checked;
      props.setCheckedDatasets(newCheckedValues);

      layer.getSource().refresh();
      setTimeout(() => layer.getSource().refresh(), 1000);
    }
  };

  const handleQueryCheckboxChange = (event, item) => {
    let layer = getQueryLayer(item);
    if (layer) {
      layer.setVisible(event.target.checked);
      let newCheckedQuerysets = { ...props.checkedQuerysets };
      newCheckedQuerysets[item.layerId] = event.target.checked;
      props.setCheckedQuerysets(newCheckedQuerysets);
    }
  };

  const onSliderChange = (value, item) => {
    let layer = getLayer(item);
    if (layer) {
      layer.setOpacity(value);
      let newOps = { ...props.opacities };
      let key = props.getItemKey(item);
      newOps[key] = value;
      props.setOpacities(newOps);
    }
  };

  const getLayer = (item) => {
    if (props.layers) {
      let gis_services = props.getGisService(item);
      for (var i = 0; i < props.layers.length; i++) {
        var layer = props.layers[i];
        let url = layer.getProperties().service_url;
        let layer_name = layer.getProperties().layer_name;
        if (
          url + '/' + layer_name ===
          gis_services.service_url + '/' + gis_services.layer_name
        ) {
          return layer;
        }
      }
    }
    return null;
  };

  // Restyle ArcGIS layers in place when their legend is recolored. Matches
  // on the map rather than props.layers, since clipping swaps in new layers.
  useEffect(() => {
    if (!props.map) return;
    selectedDatasets.forEach((item) => {
      const gis_service = props.getGisService(item);
      if (gis_service?.service_type !== 'ArcGIS') return;
      const style = buildArcGISStyle(
        gis_service.color_map,
        props.layerColors?.[props.getItemKey(item)]
      );
      props.map.getLayers().forEach((layer) => {
        if (
          layer.get('service_url') === gis_service.service_url &&
          layer.get('layer_name') === gis_service.layer_name
        ) {
          setArcGISLayerStyle(layer, style);
        }
      });
    });
  }, [props.layerColors]);

  const setLayerColorOverrides = (item, overrides) => {
    let layerColors = { ...props.layerColors };
    let key = props.getItemKey(item);
    if (overrides && Object.keys(overrides).length > 0) {
      layerColors[key] = overrides;
    } else {
      delete layerColors[key];
    }
    props.setLayerColors(layerColors);
  };

  const getQueryLayer = (item) => {
    let layer_found = null;
    if (props.map.getLayers() && item.layerId !== undefined) {
      props.map.getLayers().forEach((layer) => {
        if (layer_found == null) {
          if (layer.getProperties) {
            if (item.layerId === layer.getProperties()['layerId']) {
              layer_found = layer;
            }
          }
        }
      });
    }

    return layer_found;
  };

  const [openModal, setOpenModal] = useState(false);
  const [modalTitle] = useState('Data Report');

  const hideModal = () => {
    setOpenModal(false);
  };

  // move the scroll bar to the top for opening a popup by clicking on the map
  useEffect(() => {
    let div = document.getElementById('info');
    if (div) {
      setTimeout(() => {
        div.scrollTop = 0;
      }, 500);
    }
  }, [modalTitle]);

  const removeDatasetFromWorkspace = async (event, item) => {
    let keyToDelete = props.getItemKey(item);

    if (event) {
      for (let i = 0; i < selectedDatasets.length; i++) {
        let datasetKey = props.getItemKey(selectedDatasets[i]);
        if (keyToDelete === datasetKey) {
          let newSelectedDatasets = [...selectedDatasets];
          newSelectedDatasets.splice(i, 1);
          await setSelectedDatasets(newSelectedDatasets);

          let filterItems = { ...props.filterItems };
          delete filterItems[keyToDelete];
          await props.setFilterItems(filterItems);

          let checkedDatasets = { ...props.checkedDatasets };
          delete checkedDatasets[keyToDelete];
          await props.setCheckedDatasets(checkedDatasets);

          let opacities = { ...props.opacities };
          delete opacities[keyToDelete];
          await props.setOpacities(opacities);

          let valueRanges = { ...props.valueRanges };
          delete valueRanges[keyToDelete];
          await props.setValueRanges(valueRanges);

          if (props.layerColors?.[keyToDelete]) {
            let layerColors = { ...props.layerColors };
            delete layerColors[keyToDelete];
            props.setLayerColors(layerColors);
          }

          break;
        }
      }
    }
  };
  const findCollectionName = (item) => {
    if (item.extras) {
      const obj = item.extras.find((obj) => {
        if (obj.key === 'collection_name') {
          return obj.value;
        }
      });
      return obj ? obj.value : null;
    } else if (item.dataset_collections) {
      return item.dataset_collections[0].name;
    } else if (isAddedVectorLayer) {
      return 'Added Boundary';
    }
  };
  const getDataSources = () => {
    let dataList = selectedDatasets
      .filter((item) => {
        return findCollectionName(item);
      })
      .map((item) => findCollectionName(item));
    let data_sources = [];
    dataList.forEach((data) => {
      if (!data_sources.includes(data)) {
        data_sources.push(data);
      }
    });
    return data_sources.sort();
  };

  const removeQueryFromWorkspace = async (event, item) => {
    event.target.checked = false;
    await handleQueryCheckboxChange(event, item.mapping[0]);

    if (event) {
      let keyToDelete = item.mapping[0].layerId;

      for (let i = 0; i < props.queryLayers.length; i++) {
        let datasetKey = props.queryLayers[i].getProperties()['layerId'];
        if (keyToDelete === datasetKey) {
          let queryLayers = [...props.queryLayers];
          queryLayers.splice(i, 1);
          await props.setQueryLayers(queryLayers);
          break;
        }
      }

      let checkedQueries = { ...props.checkedQuerysets };
      checkedQueries[keyToDelete] = false;
      await props.setCheckedQuerysets(checkedQueries);

      let layer = getQueryLayer(item.mapping[0]);
      layer.setVisible(false);
      props.map.removeLayer(layer);

      for (let i = 0; i < props.queryLayerInfo.length; i++) {
        let datasetKey = props.queryLayerInfo[i].mapping[0].layerId;
        if (keyToDelete === datasetKey) {
          let queryLayerInfos = [...props.queryLayerInfo];
          queryLayerInfos.splice(i, 1);
          await props.setQueryLayerInfo(queryLayerInfos);
          break;
        }
      }
    }
  };

  // Clears one filter from the sidebar's applied-filter tags. ITS layers
  // fall back to every valid year, as resetFilter does.
  const removeFilterField = (item, field) => {
    let itemKey = props.getItemKey(item);
    let filters = { ...props.filterItems[itemKey] };
    filters[field] =
      field === 'year_txt' && itemKey.search('ITS') !== -1
        ? ITS_DATA_VALID_YEARS['year_txt']
        : undefined;
    props.setFilterItems({ ...props.filterItems, [itemKey]: filters });
    props.setValueRanges({ ...props.valueRanges, [itemKey]: filters });
  };

  const isFilterActive = () => {
    return props.queryLayerInfo.length > 0;
  };

  const resetFilter = async (item) => {
    let itemKey = props.getItemKey(item);
    let filterItems_new = { ...props.filterItems };
    let valueranges_new = { ...props.valueRanges };

    let min_max = null;

    let gis_service = props.getGisService(item);

    if (item.data_type === 'vector' || gis_service.data_type === 'vector') {
      let prevFilter = filterItems_new[itemKey];
      if (prevFilter !== undefined && prevFilter !== null) {
        Object.keys(prevFilter).forEach((key) => {
          prevFilter[key] = undefined;
          if (itemKey.search('ITS') !== -1 && key.search('year_txt') !== -1) {
            let data = ITS_DATA_VALID_YEARS['year_txt'];
            prevFilter[key] = data;
          }
          if (key == 'color') {
            delete prevFilter.color;
            let layer = getLayer(item);
            layer.getSource().setImageLoadFunction((image, src) => {
              image.getImage().src = src;
            });
          }
        });
      }

      filterItems_new[itemKey] = prevFilter;
      valueranges_new[itemKey] = prevFilter;
    } else {
      let color_map = gis_service.color_map;
      if (gis_service.categorical_values) {
        const scaleColor = chroma.scale(
          color_map.color_map_entries.map((colorData) => {
            return colorData.color;
          })
        );
        const keys = Object.keys(gis_service.categorical_values);
        const colors = scaleColor.mode('lch').colors(keys.length);
        const catData = keys.map((key, index) => {
          return { value: key, color: colors[index], visible: true };
        });
        min_max = { values: catData };
      } else if (color_map !== undefined) {
        let color_entries = color_map.color_map_entries.map((e) => {
          return { value: e.float_value, color: e.color };
        });
        const min = color_entries.reduce((min, obj) =>
          obj.age < min.age ? obj : min
        );
        const max = color_entries.reduce((min, obj) =>
          obj.age > min.age ? max : obj
        );
        min_max = {
          values: [min, max],
        };
      }
      if (min_max !== null) {
        filterItems_new[itemKey] = min_max;
        valueranges_new[itemKey] = min_max['values'];
      }
    }

    props.setFilterItems(filterItems_new);
    props.setValueRanges(valueranges_new);
  };

  const createFilterTooltip = (item) => {
    let itemGis = props.getGisService(item);
    if (itemGis.data_type == 'raster') {
      return 'Select the values or value ranges you want to display.';
    } else if (itemGis.data_type == 'vector') {
      if (itemGis.layer_name.search('boundary') !== -1) {
        return 'Select a location to filter data for that area.';
      } else if (itemGis.layer_name.search('ITS') !== -1) {
        return 'Apply filters to view specific data.';
      } else {
        console.error('tooltip failure of', itemGis.layer_name);
      }
    }
  };

  let rootStyle = {
    position: 'absolute',
    type: 'text',
    value: 'small',
    borderRadius: '6px',
  };

  let resetStyle = {
    position: 'absolute',
    left: '35px',
    padding: '1px 4px 1px 4px',
    borderRadius: '6px',
    color: '#B8B8B8',
    border: '3px solid rgba(255, 255, 255, 0.72)',
  };

  return (
    <div
      style={{
        color: '#0000a6',
        align: 'center',
        height: '100%',
        backgroundColor: '#E1E9E6',
        width: '350px',
        position: 'absolute',
        top: 0,
        right: 0,
        padding: '5px 1px 1px 4px',
        display: 'flex',
        // paddingTop: '70px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          overflowY: 'auto',
          overflowX: 'hidden',
          width: '342px',
          // justifyContent: tab == 1 ? 'space-between' : 'start',
          // height: '100vh',
        }}
      >
        <Space>
          <Tabs
            className="layer-tree-tabs"
            defaultActiveKey="1"
            tabBarGutter={16}
            style={{ marginBottom: '4px' }}
            onChange={(key) => {
              setTab(key);
            }}
            activeKey={tab}
            items={[
              {
                key: '1',
                label: (
                  <div
                    style={{
                      paddingLeft: '16px',
                      color: tab === '1' ? '#2F5F66' : '#2C3E37',
                    }}
                  >
                    <strong>Visualization Only</strong>
                  </div>
                ),
                children: (
                  <div
                    style={{
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      flexGrow: '1',
                      paddingBottom: '1px',
                      // scrollbarGutter: 'stable',
                      // height: `calc(100vh - ${controlPanelHeight + 70}px)`,
                    }}
                  >
                    <Space direction="vertical">
                      {/* ******************** Intersection ******************* */}
                      {isFilterActive() ? (
                        <Collapse
                          collapsible="icon"
                          defaultActiveKey={['1']}
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: '#CEDBD6',
                          }}
                          items={[
                            {
                              key: '1',
                              label: 'Intersection Layers',
                              children: (
                                <>
                                  {props.queryLayerInfo.map((item, i) => {
                                    return (
                                      item.mapping[0].type === 'vector' &&
                                      item.mapping[0].layerId && (
                                        <div
                                          key={'filter' + i}
                                          style={{ fontWeight: 'normal' }}
                                        >
                                          <Row>
                                            <Col span={21}>
                                              <Checkbox
                                                checked={
                                                  props.checkedQuerysets[
                                                    item.mapping[0].layerId
                                                  ]
                                                }
                                                onChange={(event) =>
                                                  handleQueryCheckboxChange(
                                                    event,
                                                    item.mapping[0]
                                                  )
                                                }
                                              >
                                                <Text
                                                  strong
                                                  style={{
                                                    fontSize: 13,
                                                    paddingRight: 5,
                                                  }}
                                                >
                                                  {item.mapping[0].name}
                                                </Text>
                                                <Tooltip
                                                  title={
                                                    item.mapping[0].tooltip
                                                  }
                                                  placement="top"
                                                >
                                                  <InfoCircleOutlined />
                                                </Tooltip>
                                              </Checkbox>
                                            </Col>
                                            <Col span={3}>
                                              <div style={rootStyle}>
                                                <Tooltip
                                                  title={
                                                    'Remove From \n Map Viewer'
                                                  }
                                                  placement="right"
                                                >
                                                  <Button
                                                    icon={
                                                      <CloseOutlined aria-hidden="true" />
                                                    }
                                                    aria-label={`Remove ${formatTitle(item.title)} from Map Viewer`}
                                                    onClick={(event) =>
                                                      removeQueryFromWorkspace(
                                                        event,
                                                        item
                                                      )
                                                    }
                                                  />
                                                </Tooltip>
                                              </div>
                                            </Col>
                                          </Row>

                                          {i <
                                          props.queryLayerInfo.length - 1 ? (
                                            <Divider
                                              style={{
                                                margin: '5px 0px 10px 0px',
                                                borderTop:
                                                  '1px solid lightgray',
                                              }}
                                            />
                                          ) : null}
                                        </div>
                                      )
                                    );
                                  })}
                                </>
                              ),
                            },
                          ]}
                        />
                      ) : null}
                      {/* ******************** All ******************* */}
                      {selectedDatasets.filter((e) => {
                        return findCollectionName(e) === 'Boundary Datasets';
                      }).length === 0 ? (
                        <>
                          <Collapse
                            collapsible="header"
                            defaultActiveKey={['1']}
                            key={1}
                            style={{
                              fontWeight: 'bold',
                              width: LAYER_PANEL_CONTENT_WIDTH,
                              backgroundColor: '#CEDBD6',
                            }}
                            items={[
                              {
                                key: 1,
                                label: BoundaryCheck('Boundary Datasets'),
                                children: (
                                  <div>
                                    {props.layersByUser?.length > 0 && (
                                      <>
                                        {' '}
                                        <hr
                                          style={{
                                            margin: '16px 0px 8px 0px',
                                            color: '#c2c0b4',
                                          }}
                                        />
                                        Custom Boundaries
                                      </>
                                    )}
                                    {props.layersByUser?.map((item, index) => {
                                      return (
                                        <span key={'layerByUser' + index}>
                                          <LayerTreeCustomBoundary
                                            item={item}
                                            rootStyle={rootStyle}
                                            layersByUser={props.layersByUser}
                                            map={props.map}
                                            checkedDatasets={
                                              props.checkedDatasets
                                            }
                                            setCheckedDatasets={
                                              props.setCheckedDatasets
                                            }
                                            getItemKey={props.getItemKey}
                                            setLayersByUser={
                                              props.setLayersByUser
                                            }
                                          />
                                        </span>
                                      );
                                    })}
                                    {props.layersByUser?.length > 0 && (
                                      <hr
                                        style={{
                                          margin: '16px 0px 4px 0px',
                                          color: '#c2c0b4',
                                        }}
                                      />
                                    )}
                                    <div
                                      style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                      }}
                                    >
                                      <Button
                                        type="primary"
                                        className="add-layer-btn"
                                        onClick={() => {
                                          navitage('/catalog', {
                                            state: { selectedBoundary: true },
                                          });
                                        }}
                                      >
                                        Click to add Boundary Layer
                                      </Button>
                                      <ForestDataMapAddLayer
                                        map={props.map}
                                        addLayerByUser={props.addLayerByUser}
                                        layers={props.layers}
                                      />
                                    </div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </>
                      ) : (
                        <>
                          {getDataSources().map((data_source, source_index) => {
                            // Boundary Section
                            if (data_source === 'Boundary Datasets') {
                              return (
                                <Collapse
                                  collapsible="header"
                                  defaultActiveKey={['1']}
                                  key={source_index}
                                  style={{
                                    fontWeight: 'bold',
                                    width: LAYER_PANEL_CONTENT_WIDTH,
                                    backgroundColor: '#CEDBD6',
                                  }}
                                  items={[
                                    {
                                      key: 1,
                                      label: BoundaryCheck(data_source),
                                      children: (
                                        <div>
                                          {selectedDatasets
                                            .filter((e) => {
                                              return (
                                                findCollectionName(e) ===
                                                data_source
                                              );
                                            })
                                            .map((item, i) => {
                                              return (
                                                <div
                                                  key={
                                                    'raster_' +
                                                    props.getItemKey(item)
                                                  }
                                                  style={{
                                                    fontWeight: 'normal',
                                                  }}
                                                >
                                                  <Row>
                                                    <Col span={21}>
                                                      <Checkbox
                                                        style={{
                                                          '--background-color':
                                                            '#3F7C85',
                                                          '--border-color':
                                                            '#2B2B2B',
                                                          borderColor:
                                                            '#2B2B2B',
                                                        }}
                                                        checked={
                                                          props.checkedDatasets[
                                                            props.getItemKey(
                                                              item
                                                            )
                                                          ]
                                                        }
                                                        onChange={(event) =>
                                                          handleCheckboxChange(
                                                            event,
                                                            item
                                                          )
                                                        }
                                                      >
                                                        <Text
                                                          strong
                                                          style={{
                                                            fontSize: 13,
                                                          }}
                                                        >
                                                          {item.title
                                                            ? formatTitle(
                                                                item.title
                                                              )
                                                            : item.name}
                                                        </Text>
                                                      </Checkbox>
                                                    </Col>
                                                    <Col span={3}>
                                                      <div style={rootStyle}>
                                                        <Tooltip
                                                          title={
                                                            'Remove From \n  Map Viewer'
                                                          }
                                                          placement="right"
                                                        >
                                                          <Button
                                                            icon={
                                                              <CloseOutlined aria-hidden="true" />
                                                            }
                                                            aria-label={`Remove ${formatTitle(item.title)} from Map Viewer`}
                                                            onClick={(event) =>
                                                              removeDatasetFromWorkspace(
                                                                event,
                                                                item
                                                              )
                                                            }
                                                          />
                                                        </Tooltip>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                  {Object.keys(
                                                    props.loading_datasets
                                                  ).filter(
                                                    (e) =>
                                                      e ===
                                                        props.getItemKey(
                                                          item
                                                        ) &&
                                                      props.loading_datasets[e]
                                                  ).length > 0 ? (
                                                    <Spin />
                                                  ) : (
                                                    <div
                                                      style={{
                                                        paddingLeft: '25px',
                                                      }}
                                                    >
                                                      <>
                                                        <Row
                                                          style={{
                                                            marginBottom: 10,
                                                          }}
                                                        >
                                                          <Col flex="none">
                                                            <div
                                                              style={{
                                                                display: 'flex',
                                                                justifyContent:
                                                                  'center',
                                                                alignItems:
                                                                  'center',
                                                                height: '30px',
                                                              }}
                                                            >
                                                              <Text
                                                                style={{
                                                                  fontSize: 13,
                                                                  paddingRight: 8,
                                                                  whiteSpace:
                                                                    'nowrap',
                                                                }}
                                                                strong
                                                              >
                                                                Border Colors
                                                              </Text>
                                                            </div>
                                                          </Col>
                                                          <Col flex="auto">
                                                            <ForestDataMapBoundaryColor
                                                              item={item}
                                                              gisData={props.getGisService(
                                                                item
                                                              )}
                                                              savedColor={
                                                                props
                                                                  .filterItems[
                                                                  props.getItemKey(
                                                                    item
                                                                  )
                                                                ]?.color?.[0]
                                                              }
                                                              setFilterItems={(
                                                                color
                                                              ) => {
                                                                let filterItems =
                                                                  {
                                                                    ...props.filterItems,
                                                                  };
                                                                let key =
                                                                  props.getItemKey(
                                                                    item
                                                                  );
                                                                filterItems[
                                                                  key
                                                                ] = {
                                                                  color: [
                                                                    color,
                                                                  ],
                                                                };
                                                                props.setFilterItems(
                                                                  filterItems
                                                                );
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </>
                                                    </div>
                                                  )}
                                                  {i <
                                                  selectedDatasets.filter(
                                                    (e) => {
                                                      return (
                                                        findCollectionName(
                                                          e
                                                        ) === data_source
                                                      );
                                                    }
                                                  ).length -
                                                    1 ? (
                                                    <Divider
                                                      style={{
                                                        margin:
                                                          '20px 0px 15px 0px',
                                                        borderTop:
                                                          '1px solid lightgray',
                                                      }}
                                                    />
                                                  ) : null}
                                                </div>
                                              );
                                            })}
                                          {props.layersByUser?.length > 0 && (
                                            <>
                                              <hr
                                                style={{
                                                  margin: '16px 0px 8px 0px',
                                                  color: '#c2c0b4',
                                                }}
                                              />
                                              Custom Boundaries
                                            </>
                                          )}
                                          {props.layersByUser?.map(
                                            (item, index) => {
                                              return (
                                                <span
                                                  key={'layerByUser' + index}
                                                >
                                                  <LayerTreeCustomBoundary
                                                    item={item}
                                                    rootStyle={rootStyle}
                                                    layersByUser={
                                                      props.layersByUser
                                                    }
                                                    map={props.map}
                                                    checkedDatasets={
                                                      props.checkedDatasets
                                                    }
                                                    setCheckedDatasets={
                                                      props.setCheckedDatasets
                                                    }
                                                    getItemKey={
                                                      props.getItemKey
                                                    }
                                                    setLayersByUser={
                                                      props.setLayersByUser
                                                    }
                                                  />
                                                </span>
                                              );
                                            }
                                          )}
                                          <hr
                                            style={{
                                              margin: '16px 0px 4px 0px',
                                              color: '#c2c0b4',
                                            }}
                                          />
                                          <div
                                            style={{
                                              width: '100%',
                                              display: 'flex',
                                              flexDirection: 'column',
                                            }}
                                          >
                                            {' '}
                                            <Button
                                              type="primary"
                                              className="add-layer-btn"
                                              onClick={() => {
                                                navitage('/catalog', {
                                                  state: {
                                                    selectedBoundary: true,
                                                  },
                                                });
                                              }}
                                            >
                                              Click to add Boundary Layer
                                            </Button>
                                            <ForestDataMapAddLayer
                                              map={props.map}
                                              addLayerByUser={
                                                props.addLayerByUser
                                              }
                                              layers={props.layers}
                                            />
                                          </div>
                                        </div>
                                      ),
                                    },
                                  ]}
                                />
                              );
                            }
                          })}
                        </>
                      )}
                      {/* ITS & CLM */}
                      {selectedDatasets.filter((e) => {
                        return findCollectionName(e) !== 'Boundary Datasets';
                      }).length !== 0 && (
                        <>
                          {getDataSources().map((data_source, source_index) => {
                            // Boundary Section
                            if (data_source !== 'Boundary Datasets') {
                              return (
                                <Collapse
                                  collapsible="header"
                                  defaultActiveKey={['1']}
                                  key={source_index}
                                  style={{
                                    fontWeight: 'bold',
                                    width: LAYER_PANEL_CONTENT_WIDTH,
                                    backgroundColor: '#CEDBD6',
                                  }}
                                  items={[
                                    {
                                      key: 1,
                                      label: data_source,
                                      children: (
                                        <div>
                                          {selectedDatasets
                                            .filter((e) => {
                                              return (
                                                findCollectionName(e) ===
                                                data_source
                                              );
                                            })
                                            .map((item, i) => {
                                              const itemGis =
                                                props.getGisService(item);
                                              const isAllITS =
                                                itemGis.layer_name.search(
                                                  'ITS:'
                                                ) === -1
                                                  ? false
                                                  : true;
                                              return (
                                                <div
                                                  key={
                                                    'raster_' +
                                                    props.getItemKey(item)
                                                  }
                                                  style={{
                                                    fontWeight: 'normal',
                                                  }}
                                                >
                                                  <Row>
                                                    <Col span={21}>
                                                      <Checkbox
                                                        style={{
                                                          '--background-color':
                                                            '#3F7C85',
                                                          '--border-color':
                                                            '#2B2B2B',
                                                          borderColor:
                                                            '#2B2B2B',
                                                        }}
                                                        checked={
                                                          props.checkedDatasets[
                                                            props.getItemKey(
                                                              item
                                                            )
                                                          ]
                                                        }
                                                        onChange={(event) =>
                                                          handleCheckboxChange(
                                                            event,
                                                            item
                                                          )
                                                        }
                                                      >
                                                        <Text
                                                          strong
                                                          style={{
                                                            fontSize: 13,
                                                          }}
                                                        >
                                                          {item.title
                                                            ? formatTitle(
                                                                item.title
                                                              )
                                                            : item.name}
                                                        </Text>
                                                      </Checkbox>
                                                    </Col>
                                                    <Col span={3}>
                                                      <div style={rootStyle}>
                                                        <Tooltip
                                                          title={
                                                            'Remove From \n  Map Viewer'
                                                          }
                                                          placement="right"
                                                        >
                                                          <Button
                                                            icon={
                                                              <CloseOutlined aria-hidden="true" />
                                                            }
                                                            aria-label={`Remove ${formatTitle(item.title)} from Map Viewer`}
                                                            onClick={(event) =>
                                                              removeDatasetFromWorkspace(
                                                                event,
                                                                item
                                                              )
                                                            }
                                                          />
                                                        </Tooltip>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                  {Object.keys(
                                                    props.loading_datasets
                                                  ).filter(
                                                    (e) =>
                                                      e ===
                                                        props.getItemKey(
                                                          item
                                                        ) &&
                                                      props.loading_datasets[e]
                                                  ).length > 0 ? (
                                                    <Spin />
                                                  ) : (
                                                    <div
                                                      style={{
                                                        paddingLeft: '25px',
                                                      }}
                                                    >
                                                      <>
                                                        <Row align="middle">
                                                          <Col span={8}>
                                                            <Text
                                                              style={{
                                                                fontSize: 13,
                                                                paddingRight: 4,
                                                                alignSelf:
                                                                  'center',
                                                              }}
                                                            >
                                                              Opacity
                                                            </Text>
                                                            <Tooltip
                                                              title={`Use the slider to change the layer's transparency. Slide left to make it more transparent, right to make it more visible.`}
                                                              placement="top"
                                                              data-html="true"
                                                            >
                                                              <InfoCircleOutlined />
                                                            </Tooltip>
                                                          </Col>
                                                          <Col span={14}>
                                                            <Slider
                                                              ariaLabelForHandle={`Opacity of ${formatTitle(item.title)}`}
                                                              style={{
                                                                width: '130px',
                                                              }}
                                                              trackStyle={{
                                                                backgroundColor:
                                                                  '#3F7C85',
                                                              }}
                                                              min={0}
                                                              max={1}
                                                              step={0.01}
                                                              value={
                                                                props.opacities[
                                                                  props.getItemKey(
                                                                    item
                                                                  )
                                                                ] || 0.6
                                                              }
                                                              onChange={(
                                                                value
                                                              ) =>
                                                                onSliderChange(
                                                                  value,
                                                                  item
                                                                )
                                                              }
                                                              disabled={
                                                                !props
                                                                  .checkedDatasets[
                                                                  props.getItemKey(
                                                                    item
                                                                  )
                                                                ]
                                                              }
                                                            />
                                                          </Col>
                                                        </Row>
                                                        {isAllITS && (
                                                          <Row
                                                            style={{
                                                              marginBottom: 10,
                                                            }}
                                                          >
                                                            <Col span={8}>
                                                              <Text
                                                                style={{
                                                                  fontSize: 13,
                                                                  paddingRight: 4,
                                                                }}
                                                              >
                                                                Filter
                                                              </Text>
                                                              <Tooltip
                                                                title={createFilterTooltip(
                                                                  item
                                                                )}
                                                                placement="top"
                                                                data-html="true"
                                                              >
                                                                <InfoCircleOutlined />
                                                              </Tooltip>
                                                            </Col>
                                                            <Col span={16}>
                                                              <span>
                                                                <FilterModalIts
                                                                  item={item}
                                                                  getGisService={
                                                                    props.getGisService
                                                                  }
                                                                  getItemKey={
                                                                    props.getItemKey
                                                                  }
                                                                  filtersDatasets={
                                                                    props.filtersDatasets
                                                                  }
                                                                  setFilterDatasets={
                                                                    props.setFilterDatasets
                                                                  }
                                                                  filterItems={
                                                                    props.filterItems
                                                                  }
                                                                  setFilterItems={
                                                                    props.setFilterItems
                                                                  }
                                                                  filter_options={
                                                                    props.filter_options
                                                                  }
                                                                  setFilterOptions={
                                                                    props.setFilterOptions
                                                                  }
                                                                  layers={
                                                                    props.layers
                                                                  }
                                                                />
                                                              </span>
                                                              <span>
                                                                <Tooltip
                                                                  title="Reset Filter"
                                                                  placement="top"
                                                                >
                                                                  <Button
                                                                    style={
                                                                      resetStyle
                                                                    }
                                                                    icon={
                                                                      <UndoOutlined />
                                                                    }
                                                                    disabled={
                                                                      !props
                                                                        .filterItems[
                                                                        // Default view for ITS data is the years in ITS_DATA_VALID_YEARS
                                                                        props.getItemKey(
                                                                          item
                                                                        )
                                                                      ] ||
                                                                      (props
                                                                        .filterItems[
                                                                        props.getItemKey(
                                                                          item
                                                                        )
                                                                      ] &&
                                                                        JSON.stringify(
                                                                          props
                                                                            .filterItems[
                                                                            props.getItemKey(
                                                                              item
                                                                            )
                                                                          ]
                                                                        ) ===
                                                                          JSON.stringify(
                                                                            ITS_DATA_VALID_YEARS
                                                                          ))
                                                                    }
                                                                    onClick={() =>
                                                                      resetFilter(
                                                                        item
                                                                      )
                                                                    }
                                                                  />
                                                                </Tooltip>
                                                              </span>
                                                            </Col>
                                                          </Row>
                                                        )}
                                                        <AppliedFilters
                                                          filters={
                                                            props.filterItems[
                                                              props.getItemKey(
                                                                item
                                                              )
                                                            ]
                                                          }
                                                          onRemove={(field) =>
                                                            removeFilterField(
                                                              item,
                                                              field
                                                            )
                                                          }
                                                        />
                                                      </>
                                                    </div>
                                                  )}

                                                  {!isAllITS && (
                                                    <ForestDataMapLegend
                                                      item={item}
                                                      itemGis={itemGis}
                                                      colorOverrides={
                                                        props.layerColors?.[
                                                          props.getItemKey(item)
                                                        ]
                                                      }
                                                      setColorOverrides={(
                                                        overrides
                                                      ) =>
                                                        setLayerColorOverrides(
                                                          item,
                                                          overrides
                                                        )
                                                      }
                                                      key={props.getItemKey(
                                                        item
                                                      )}
                                                    />
                                                  )}
                                                  {i <
                                                  selectedDatasets.filter(
                                                    (e) => {
                                                      return (
                                                        findCollectionName(
                                                          e
                                                        ) === data_source
                                                      );
                                                    }
                                                  ).length -
                                                    1 ? (
                                                    <Divider
                                                      style={{
                                                        margin:
                                                          '20px 0px 15px 0px',
                                                        borderTop:
                                                          '1px solid lightgray',
                                                      }}
                                                    />
                                                  ) : null}
                                                </div>
                                              );
                                            })}
                                        </div>
                                      ),
                                    },
                                  ]}
                                />
                              );
                            }
                          })}
                        </>
                      )}
                      <>
                        <Card
                          style={{
                            width: LAYER_PANEL_CONTENT_WIDTH,
                            borderRadius: '12px',
                            border: `1px solid #2C3E3722`, // Subtle green border
                            boxShadow: '0 8px 24px rgba(82, 83, 53, 0.12)', // Tinted shadow
                          }}
                        >
                          <Button
                            type="primary"
                            className="add-layer-btn"
                            onClick={() => navitage('/catalog')}
                          >
                            Click to add Data Layers
                          </Button>
                        </Card>
                      </>
                    </Space>
                  </div>
                ),
              },
              {
                key: '2',
                label: (
                  <div style={{ color: tab === '2' ? '#2F5F66' : '#2C3E37' }}>
                    <strong>Download & Reporting</strong>
                  </div>
                ),
              },
            ]}
          />
        </Space>
        <LayerTreeControl
          map={props.map}
          layers={props.layers}
          filterItems={props.filterItems}
          layersByUser={props.layersByUser}
          selectedDatasets={selectedDatasets}
          getGisService={props.getGisService}
          access_token={props.access_token}
          getItemKey={props.getItemKey}
          opacities={props.opacities}
          layerColors={props.layerColors}
          filter_options={props.filter_options}
          tab={tab}
          clipLayer={props.clipLayer}
          setClipLayer={props.setClipLayer}
          selectedClipBoundary={props.selectedClipBoundary}
          setSelectedClipBoundary={props.setSelectedClipBoundary}
          selectedCustomClipKey={props.selectedCustomClipKey}
          setSelectedCustomClipKey={props.setSelectedCustomClipKey}
          selectedClipSubset={props.selectedClipSubset}
          setSelectedClipSubset={props.setSelectedClipSubset}
          clipEnabled={props.clipEnabled}
          setClipEnabled={props.setClipEnabled}
          highlightClip={props.highlightClip}
          setHighlightClip={props.setHighlightClip}
        />
      </div>

      <Modal
        title={modalTitle}
        open={openModal}
        onCancel={hideModal}
        okText="OK"
        cancelText="Cancel"
        width={900}
        footer={
          <div textAlign="left">
            * All text in this report has been created by conversational AI. You
            can edit the data title and description.
          </div>
        }
      ></Modal>
    </div>
  );
};

export default ForestDataMapLayerTree;
